export default "__VITE_ASSET__BObov70v__"